import _slicedToArray from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 1,
  class: "order-details-page-bottom"
};
var _hoisted_3 = {
  class: "cart-info"
};
var _hoisted_4 = {
  class: "cart-info-label"
};
var _hoisted_5 = {
  class: "cart-info-value"
};
var _hoisted_6 = {
  class: "bottom-button-wrap"
};
var _hoisted_7 = {
  key: 2,
  class: "order-details-page-bottom invoice"
};
var _hoisted_8 = {
  class: "order-detail-payment-method-wrap"
};
import OrderStatusCard from "@/components/order/OrderStatusCard.vue";
import OrderCustomerCard from "@/components/order/OrderCustomerCard.vue";
import OrderDetailCard from "@/components/order/OrderDetailCard.vue";
import OrderItemsCard from "@/components/order/OrderItemsCard.vue";
import { getOrderDetail, queryOnlinePayment } from "@/api/order";
import { ref, onMounted } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { priceUtil } from "@op/shared";
import { showToast } from "@/utils/toastUtil";
import PaymentMethodVue from "@/components/order/PaymentMethod.vue";
import { Notify } from "@/utils/notifyUtil";
import Common from "@/components/dialog/src/Common.vue";
import { useUserStoreWithOut } from "@/store/userStore";
import { createDeliveryOrderOnlinePay } from "@/api/order";
import PoweredBy from "@/components/PoweredBy.vue";
import { OrderStatusEnum } from "@/constant/order";
import BusinessTrigger from "@/components/reward/BusinessTrigger.vue";
import { useSupplierStore } from "@/store/supplierStore";
import PointDialog from "@/components/activity/PointDialog.vue";
import { askPushSubscription } from "@/utils/PushSubscriptionUtil";
import { useRouter } from "@/hooks/useRouter";
import InvoiceTrigger from "@/components/invoice/InvoiceTrigger";
import { isTimestampInCurrentMonth } from "@/utils/dateUtil";
import { createOnlinePay } from "@op/shared";
import { useI18n } from "vue-i18n";
import Dialog from "@/components/dialog/dialog";
import { isProd, toCalSubCharge } from "@/utils/tools";
export default {
  __name: 'OrderDetail',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush,
      routerBack = _useRouter.routerBack;
    var routes = useRoute();
    var userStore = useUserStoreWithOut();
    var supplierStore = useSupplierStore();
    var orderId = computed(function () {
      return routes.query.id;
    });
    var order = ref(null);
    // 使用了礼品卡或积分抵扣，则隐藏cod支付方式
    var invalidMethodList = computed(function () {
      var _order$value, _order$value2;
      return ((_order$value = order.value) === null || _order$value === void 0 || (_order$value = _order$value.fare) === null || _order$value === void 0 || (_order$value = _order$value.gift_card_info) === null || _order$value === void 0 ? void 0 : _order$value.amount) > 0 || ((_order$value2 = order.value) === null || _order$value2 === void 0 || (_order$value2 = _order$value2.fare) === null || _order$value2 === void 0 || (_order$value2 = _order$value2.points_info) === null || _order$value2 === void 0 ? void 0 : _order$value2.amount) > 0 ? ["cod"] : null;
    });
    // 使用礼品卡或积分，且订单金额被全额抵扣
    var isFullPriceRedeemed = computed(function () {
      var _order$value3, _order$value4, _order$value5;
      return (((_order$value3 = order.value) === null || _order$value3 === void 0 || (_order$value3 = _order$value3.fare) === null || _order$value3 === void 0 || (_order$value3 = _order$value3.gift_card_info) === null || _order$value3 === void 0 ? void 0 : _order$value3.amount) > 0 || ((_order$value4 = order.value) === null || _order$value4 === void 0 || (_order$value4 = _order$value4.fare) === null || _order$value4 === void 0 || (_order$value4 = _order$value4.points_info) === null || _order$value4 === void 0 ? void 0 : _order$value4.amount) > 0) && ((_order$value5 = order.value) === null || _order$value5 === void 0 || (_order$value5 = _order$value5.fare) === null || _order$value5 === void 0 ? void 0 : _order$value5.customer_total_display) === 0;
    });
    var paymentMethodRef = ref();
    var grandTotal = computed(function () {
      var _order$value$fare$cus, _order$value$fare, _paymentMethod$value;
      var res = (_order$value$fare$cus = (_order$value$fare = order.value.fare) === null || _order$value$fare === void 0 ? void 0 : _order$value$fare.customer_total_display) !== null && _order$value$fare$cus !== void 0 ? _order$value$fare$cus : 0;
      var subChargeRate = paymentMethod === null || paymentMethod === void 0 || (_paymentMethod$value = paymentMethod.value) === null || _paymentMethod$value === void 0 || (_paymentMethod$value = _paymentMethod$value.subCharge) === null || _paymentMethod$value === void 0 ? void 0 : _paymentMethod$value.rate;
      if (subChargeRate) {
        var _toCalSubCharge;
        res += (_toCalSubCharge = toCalSubCharge(res, subChargeRate)) !== null && _toCalSubCharge !== void 0 ? _toCalSubCharge : 0;
      }
      return res;
    });
    var isInvoice = computed(function () {
      var _order$value$times;
      if (!order.value) return false;
      return order.value.status === OrderStatusEnum.COMPLETED && isTimestampInCurrentMonth((_order$value$times = order.value.times) === null || _order$value$times === void 0 ? void 0 : _order$value$times.order_at);
    });
    var allowReload = computed(function () {
      var _supplierStore$getSup, _supplierStore$getSup2;
      return (_supplierStore$getSup = (_supplierStore$getSup2 = supplierStore.getSupplierTopUpSetting) === null || _supplierStore$getSup2 === void 0 ? void 0 : _supplierStore$getSup2.allow_top_up_at_mini_program) !== null && _supplierStore$getSup !== void 0 ? _supplierStore$getSup : true;
    });
    var isSubmitButtonDisabled = computed(function () {
      var _paymentMethod$value2, _order$value$fare2, _paymentMethodRef$val;
      return !paymentMethod.value || ((_paymentMethod$value2 = paymentMethod.value) === null || _paymentMethod$value2 === void 0 ? void 0 : _paymentMethod$value2.method) === "balance" && userStore.getWallet < ((_order$value$fare2 = order.value.fare) === null || _order$value$fare2 === void 0 ? void 0 : _order$value$fare2.customer_total_display) && (!allowReload.value || ((_paymentMethodRef$val = paymentMethodRef.value) === null || _paymentMethodRef$val === void 0 ? void 0 : _paymentMethodRef$val.onlinePaymentOptions.length) <= 0);
    });
    var submitButtonText = computed(function () {
      var _paymentMethod$value3, _order$value$fare3;
      if (((_paymentMethod$value3 = paymentMethod.value) === null || _paymentMethod$value3 === void 0 ? void 0 : _paymentMethod$value3.method) === "balance" && userStore.getWallet < ((_order$value$fare3 = order.value.fare) === null || _order$value$fare3 === void 0 ? void 0 : _order$value$fare3.customer_total_display)) {
        var _paymentMethodRef$val2;
        // 选择余额且余额不足
        if (!allowReload.value) {
          return t("insufficientBalance");
        } else if (((_paymentMethodRef$val2 = paymentMethodRef.value) === null || _paymentMethodRef$val2 === void 0 ? void 0 : _paymentMethodRef$val2.onlinePaymentOptions.length) > 0) {
          return t("insufficientBalancePleaseTopUp");
        } else {
          return t("notEnoughBalancePleaseTopUpInStore");
        }
      } else {
        return t("confirm");
      }
    });
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              order.value = null;
              showLoading();
              _context.next = 4;
              return getOrderDetail(orderId.value);
            case 4:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                order.value = res.data;
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    var deliveryMethod = computed(function () {
      return userStore.getOrderType;
    });
    var handleCheckId = ref(0);
    var timer = ref(null);
    var curTime = ref(0);
    var showNotCompletePopup = ref(false);
    var paymentResultMap = ref({
      PAID_FINISH: "paid_finish",
      // paid_finish：支付成功
      UNPAID: "unpaid",
      // unpaid：有支付单，未完成支付
      NOT_PAID: "not_paid",
      // not_paid：无支付单
      PAID_FAIL: "paid_fail" // paid_fail: 支付失败
    });
    // const payFailReason = ref("");
    var isNotPayYet = ref(false);
    var isPaymentMethodShow = ref(false);
    function handleCheck() {
      // 更新handleCheckId
      var handleCheckIdValue = handleCheckId.value;
      var curHandleCheckId = handleCheckId.value = handleCheckIdValue + 1;
      showLoading(t("checking"));
      simpleCountDown(3);
      var _checkOnlinePayment = function checkOnlinePayment() {
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var res;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return queryOnlinePayment({
                  order_id: order.value.order_id
                });
              case 2:
                res = _context2.sent;
                if (curHandleCheckId === handleCheckId.value && res.isOK && res.data) {
                  if (res.data.payment_result === paymentResultMap.value.PAID_FINISH) {
                    curHandleCheckId = 0;
                    hideLoading();
                    Notify.success(t("orderedSuccessful"));
                  } else if (res.data.payment_result === paymentResultMap.value.PAID_FAIL) {
                    curHandleCheckId = 0;
                    hideLoading();
                    Notify.error(t("paymentFailed"));
                    isNotPayYet.value = true;
                    // payFailReason.value = res.data.fail_reason;
                  } else {
                    if (curTime.value === 0) {
                      curHandleCheckId = 0;
                      hideLoading();
                      showNotCompletePopup.value = true;
                    } else {
                      _checkOnlinePayment();
                    }
                  }
                } else {
                  curHandleCheckId = 0;
                  hideLoading();
                  showNotCompletePopup.value = true;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })), 500);
      };
      _checkOnlinePayment();

      // 倒计时结束，查询仍未结束
      setTimeout(function () {
        if (curHandleCheckId === handleCheckId.value) {
          curHandleCheckId = 0;
          hideLoading();
          showNotCompletePopup.value = true;
        }
      }, 3000);
    }
    function simpleCountDown(time) {
      timer.value && clearTimeout(timer.value);
      if (time < 0) {
        return;
      }
      curTime.value = time;
      timer.value = setTimeout(function () {
        simpleCountDown(time - 1);
      }, 1000);
    }
    function onClickNotPay() {
      showNotCompletePopup.value = false;
      isNotPayYet.value = true;
    }
    function onClickHavePaid() {
      showNotCompletePopup.value = false;
      handleCheck();
    }
    function handleShowPaymentMethod() {
      // 使用礼品卡或积分，且全额抵扣时，不需要打开支付方法选择，直接创建支付单
      if (isFullPriceRedeemed.value) {
        handlePay();
      } else {
        // 打开支付方法选择
        isPaymentMethodShow.value = true;
      }
    }
    var isCancelled = computed(function () {
      var _order$value6;
      return [OrderStatusEnum.CANCELLED, OrderStatusEnum.TO_DELIVER_CANCELLED, OrderStatusEnum.DELIVERING_CANCELLED, OrderStatusEnum.READY_CANCELLED, OrderStatusEnum.REJECT_CANCELLED].includes((_order$value6 = order.value) === null || _order$value6 === void 0 ? void 0 : _order$value6.status);
    });
    var businessTrigger = ref(null);
    var showBannerTrigger = computed(function () {
      var _businessTrigger$valu, _order$value7;
      return ((_businessTrigger$valu = businessTrigger.value) === null || _businessTrigger$valu === void 0 || (_businessTrigger$valu = _businessTrigger$valu.banner) === null || _businessTrigger$valu === void 0 ? void 0 : _businessTrigger$valu.is_open) && !isCancelled.value && ![OrderStatusEnum.TO_PAY].includes((_order$value7 = order.value) === null || _order$value7 === void 0 ? void 0 : _order$value7.status);
    });
    var showPointDialog = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _businessTrigger$valu2;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!routes.query.id) {
              _context3.next = 12;
              break;
            }
            _context3.next = 3;
            return fetchData();
          case 3:
            // 当query中有callback时，认为是在在线支付cancel的回调流程中
            if (routes.query.callback) {
              if (order.value.status === OrderStatusEnum.TO_PAY) {
                handleCheck();
              } else if ([OrderStatusEnum.TO_ACCEPT, OrderStatusEnum.PREPARING, OrderStatusEnum.COMPLETED].includes(order.value.status)) {
                Notify.success(t("orderedSuccessful"));
              }
            }
            _context3.next = 6;
            return supplierStore.setBusinessTriggerList();
          case 6:
            businessTrigger.value = supplierStore.getBusinessTriggerList.find(function (item) {
              return item.trigger_type === "order_detail";
            });
            showPointDialog.value = (_businessTrigger$valu2 = businessTrigger.value) === null || _businessTrigger$valu2 === void 0 || (_businessTrigger$valu2 = _businessTrigger$valu2.popup) === null || _businessTrigger$valu2 === void 0 ? void 0 : _businessTrigger$valu2.is_open;

            // 询问是否订阅推送
            _context3.next = 10;
            return askPushSubscription();
          case 10:
            _context3.next = 12;
            break;
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    var paymentMethod = ref(null);
    function handleSelectPaymentMethod(val) {
      paymentMethod.value = val;
    }

    // 使用礼品卡或积分，且全额抵扣时，paymentMethod.value为null
    function handlePay() {
      return _handlePay.apply(this, arguments);
    } // 页面后退
    function _handlePay() {
      _handlePay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _paymentMethod$value4, _order$value$fare5, _paymentMethodRef$val3, _replace, _replace2, _order$value8, _order$value9, _order$value10, _order$value$delivery, _order$value$delivery2, _order$value$delivery3, _order$value$delivery4;
        var paymentMethodValue, success_url, cancel_url, successUrl, cancelUrl, _ref4, _ref5, firstName, lastName;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(((_paymentMethod$value4 = paymentMethod.value) === null || _paymentMethod$value4 === void 0 ? void 0 : _paymentMethod$value4.method) === "balance" && userStore.getWallet < ((_order$value$fare5 = order.value.fare) === null || _order$value$fare5 === void 0 ? void 0 : _order$value$fare5.customer_total_display) && ((_paymentMethodRef$val3 = paymentMethodRef.value) === null || _paymentMethodRef$val3 === void 0 ? void 0 : _paymentMethodRef$val3.onlinePaymentOptions.length) > 0 && allowReload.value)) {
                _context4.next = 3;
                break;
              }
              // 跳转去充值页
              routerPush({
                name: "Recharge",
                query: {
                  redirect: "order_detail",
                  order_id: orderId.value
                }
              });
              return _context4.abrupt("return");
            case 3:
              paymentMethodValue = paymentMethod.value;
              success_url = (_replace = ((paymentMethodValue === null || paymentMethodValue === void 0 ? void 0 : paymentMethodValue.success_url) || "".concat(window.location.origin).concat(window.location.pathname, "#", "/home/order?id=${order_id}&callback=1")).replace("${order_id}", orderId.value)) !== null && _replace !== void 0 ? _replace : "";
              cancel_url = (_replace2 = ((paymentMethodValue === null || paymentMethodValue === void 0 ? void 0 : paymentMethodValue.cancel_url) || "".concat(window.location.origin).concat(window.location.pathname, "#", "/home/order?id=${order_id}&callback=1")).replace("${order_id}", orderId.value)) !== null && _replace2 !== void 0 ? _replace2 : "";
              successUrl = paymentMethodValue !== null && paymentMethodValue !== void 0 && paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(success_url) : success_url;
              cancelUrl = paymentMethodValue !== null && paymentMethodValue !== void 0 && paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(cancel_url) : cancel_url;
              _ref4 = (_order$value8 = order.value) !== null && _order$value8 !== void 0 && _order$value8.customer ? (_order$value9 = order.value) === null || _order$value9 === void 0 ? void 0 : _order$value9.customer.name.split(" ") : [], _ref5 = _slicedToArray(_ref4, 2), firstName = _ref5[0], lastName = _ref5[1];
              showLoading();
              createOnlinePay({
                srv: createDeliveryOrderOnlinePay,
                orderId: orderId.value,
                paymentChannel: isFullPriceRedeemed.value ? {
                  value: undefined
                } : paymentMethodValue,
                successUrl: successUrl,
                cancelUrl: cancelUrl,
                onError: function onError() {
                  hideLoading();
                  showToast(t("createOnlinePayFailed"));
                },
                shopname: (_order$value10 = order.value) === null || _order$value10 === void 0 || (_order$value10 = _order$value10.op_store) === null || _order$value10 === void 0 ? void 0 : _order$value10.name,
                addressData: {
                  firstName: firstName,
                  lastName: lastName,
                  address: (_order$value$delivery = order.value.delivery_address) === null || _order$value$delivery === void 0 ? void 0 : _order$value$delivery.street,
                  city: (_order$value$delivery2 = order.value.delivery_address) === null || _order$value$delivery2 === void 0 ? void 0 : _order$value$delivery2.city,
                  state: (_order$value$delivery3 = order.value.delivery_address) === null || _order$value$delivery3 === void 0 ? void 0 : _order$value$delivery3.state,
                  zipCode: (_order$value$delivery4 = order.value.delivery_address) === null || _order$value$delivery4 === void 0 ? void 0 : _order$value$delivery4.postal_code
                },
                paymentshubPayPageUrl: process.env.VUE_APP_PAYMENTSHUB_PAY_PAGE_URL,
                paymentshubRedirectUrl: process.env.VUE_APP_PAYMENTSHUB_REDIRECT_URL,
                otherParams: {
                  staging: !isProd,
                  onConfirm: function onConfirm(cb) {
                    Dialog.confirm({
                      title: t("warning"),
                      desc: t("sureToClose"),
                      okText: t("yes"),
                      cancelText: t("no"),
                      onOk: function onOk() {
                        cb === null || cb === void 0 || cb();
                      }
                    });
                  },
                  onReady: function onReady() {
                    hideLoading();
                  }
                }
              });
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _handlePay.apply(this, arguments);
    }
    function handlePageBack() {
      if (routes.query.back_to_home) {
        routerPush({
          name: "Index"
        });
      } else if (routes.query.back_to_orders) {
        routerPush({
          name: "Orders"
        });
      } else {
        routerBack();
      }
    }
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('orderDetails'),
        "is-yellow-bg": "",
        "on-back": handlePageBack
      }, {
        default: _withCtx(function () {
          var _order$value$fare4, _order$value$invoice_;
          return [order.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["order-detail", {
              'order-detail--not-pay': isNotPayYet.value || isInvoice.value
            }])
          }, [_createVNode(OrderStatusCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), showBannerTrigger.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BusinessTrigger, {
            class: "panel business-trigger overflow-hidden",
            "business-trigger": businessTrigger.value
          }, null, 8, ["business-trigger"]), _createVNode(_component_Gap, {
            h: 0.1
          })])) : _createCommentVNode("", true), _createVNode(OrderCustomerCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(OrderItemsCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(OrderDetailCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(PoweredBy)], 2)) : _createCommentVNode("", true), order.value && isNotPayYet.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("orderDetails")), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(grandTotal.value, (_order$value$fare4 = order.value.fare) === null || _order$value$fare4 === void 0 ? void 0 : _order$value$fare4.currency)), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_Button, {
            class: "bottom-button",
            onClick: _withModifiers(handleShowPaymentMethod, ["stop"])
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("payNow")), 1)];
            }),
            _: 1
          })])])) : _createCommentVNode("", true), order.value && isInvoice.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(InvoiceTrigger), {
            class: "bottom-button-wrap",
            "record-id": ((_order$value$invoice_ = order.value.invoice_info) === null || _order$value$invoice_ === void 0 ? void 0 : _order$value$invoice_.id) || '',
            "order-id": order.value.order_id,
            "shop-id": order.value.op_store.shop_id,
            "order-type": 'delivery',
            onSuccess: fetchData
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Button, {
                class: "bottom-button",
                type: "border"
              }, {
                default: _withCtx(function () {
                  var _order$value$invoice_2;
                  return [_createTextVNode(_toDisplayString((_order$value$invoice_2 = order.value.invoice_info) !== null && _order$value$invoice_2 !== void 0 && _order$value$invoice_2.id ? _ctx.$t("viewInvoice") : _ctx.$t("issueInvoice")), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["record-id", "order-id", "shop-id"])])) : _createCommentVNode("", true), _createVNode(Common, {
            visible: showNotCompletePopup.value,
            "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
              return showNotCompletePopup.value = $event;
            }),
            title: _ctx.$t('resultChecking'),
            desc: _ctx.$t('didYouFinishThePayment'),
            "ok-text": _ctx.$t('yes'),
            "cancel-text": _ctx.$t('noYet'),
            "on-cancel": onClickNotPay,
            "on-ok": onClickHavePaid,
            "cancel-on-click-overlay": true,
            "hide-bottom-shadow": true
          }, null, 8, ["visible", "title", "desc", "ok-text", "cancel-text"]), _createVNode(Common, {
            visible: isPaymentMethodShow.value,
            "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
              return isPaymentMethodShow.value = $event;
            }),
            position: "bottom",
            title: _ctx.$t('selectPaymentMethods'),
            "show-close-btn": "",
            "ok-text": submitButtonText.value,
            "without-cancel": "",
            "on-ok": handlePay,
            "disable-ok-button": isSubmitButtonDisabled.value
          }, {
            content: _withCtx(function () {
              var _order$value$op_store;
              return [_createElementVNode("div", _hoisted_8, [_createVNode(PaymentMethodVue, {
                ref_key: "paymentMethodRef",
                ref: paymentMethodRef,
                "delivery-method": deliveryMethod.value,
                "shop-id": (_order$value$op_store = order.value.op_store) === null || _order$value$op_store === void 0 ? void 0 : _order$value$op_store.shop_id,
                "invalid-method-list": invalidMethodList.value,
                onChange: handleSelectPaymentMethod
              }, null, 8, ["delivery-method", "shop-id", "invalid-method-list"])])];
            }),
            _: 1
          }, 8, ["visible", "title", "ok-text", "disable-ok-button"]), _createVNode(PointDialog, {
            visible: showPointDialog.value,
            "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
              return showPointDialog.value = $event;
            }),
            trigger: businessTrigger.value,
            "trigger-type": "order_detail"
          }, null, 8, ["visible", "trigger"])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};